module.exports = __webpack_public_path__ + "assets/img/returnBtn-50b48efa.png";